import React, { useState } from "react";
import { LogOut, Undo2, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { api } from "@/lib/api";

const today = () => new Date().toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" });

export const LeftControl = ({ s, onChanged }) => {
  const [open, setOpen] = useState(false);
  const [d, setD] = useState(today());
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const call = async (path, body, msg) => {
    setBusy(true);
    try { await api.post(`/admin/students/${s.id}/${path}`, body); toast.success(msg); setOpen(false); onChanged?.(); }
    catch (e) { toast.error(e.response?.data?.detail || "Could not update"); } finally { setBusy(false); }
  };
  if (s.left) return (
    <div className="mt-4 rounded-lg border border-slate-300 bg-slate-100 p-3 text-sm flex flex-wrap items-center gap-2" data-testid="left-info">
      <span className="font-semibold text-slate-700">Left PTG on {s.left_date}</span>
      {s.left_reason && <span className="text-slate-500">— {s.left_reason}</span>}
      <span className="w-full text-xs text-slate-500">Hidden from teachers, login blocked, no automatic fee reminders. All history is kept.</span>
      <Button size="sm" variant="outline" disabled={busy} onClick={() => call("bring-back", {}, `${s.name} is active again`)} data-testid="bring-back-btn">
        {busy ? <Loader2 className="h-4 w-4 mr-1 animate-spin" /> : <Undo2 className="h-4 w-4 mr-1" />} Bring back
      </Button>
    </div>
  );
  if (!open) return (
    <Button size="sm" variant="outline" className="mt-4 text-red-700 border-red-200 hover:bg-red-50" onClick={() => setOpen(true)} data-testid="mark-left-btn">
      <LogOut className="h-4 w-4 mr-1" /> Mark as left
    </Button>
  );
  return (
    <div className="mt-4 rounded-lg border border-red-200 bg-red-50 p-3 space-y-2 text-sm" data-testid="mark-left-form">
      <p className="text-red-800">The student will disappear from teacher lists, their login will be blocked and automatic fee reminders stop. Fees, receipts and attendance are kept.</p>
      <div className="flex flex-wrap gap-2">
        <Input type="date" value={d} onChange={(e) => setD(e.target.value)} className="h-9 w-[160px] bg-white" data-testid="left-date" />
        <Input value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Reason (e.g. moved city)" className="h-9 flex-1 min-w-[180px] bg-white" data-testid="left-reason" />
      </div>
      <div className="flex gap-2">
        <Button size="sm" variant="outline" onClick={() => setOpen(false)}>Cancel</Button>
        <Button size="sm" className="bg-red-700 hover:bg-red-800" disabled={busy || !d} onClick={() => call("left", { left_date: d, reason }, `${s.name} marked as left`)} data-testid="left-confirm">
          {busy && <Loader2 className="h-4 w-4 mr-1 animate-spin" />} Confirm left
        </Button>
      </div>
    </div>
  );
};
